import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import {
    GridFacade,
    GridFilter,
    GridFilterGroup,
} from "@hermes/states/grid-filters-state";
import { GridFilterIdSetterPipe } from "@hermes/trays/grid-filters";
import { FocusService } from "@hermes/utils-generic/services/focus";

@Component({
    selector: "h-grid-filter-checkbox",
    templateUrl: "./grid-filter-checkbox.component.html",
    styleUrls: ["./grid-filter-checkbox.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFilterCheckboxComponent {
    @Input()
    public gridFilterGroup: GridFilterGroup;

    @Input()
    public isExpanded: boolean;

    constructor(
        private gridFilterIdSetterPipe: GridFilterIdSetterPipe,
        private gridFacade: GridFacade,
        private focusService: FocusService,
    ) {}

    public toggleFilter(filter: GridFilter): void {
        filter.selected = !filter.selected;
        this.focusService.elementToFocus =
            this.gridFilterIdSetterPipe.transform(filter, this.gridFilterGroup);
        this.gridFacade.updateGridFilter(filter, this.gridFilterGroup);
    }

    public trackByFilter(index: number, filter: GridFilter): string {
        return `${index}_${filter?.name}`;
    }
}
